<template>
	<div :class="['step-title', { 'is-disabled': isDisabled, 'has-slot-content': $slots.default }]">
		<div class="step-title__title-wrapper">
			<CircleNumber class="step-title__number" :value="number" />

			<h2 class="step-title__title">{{ text }}</h2>
		</div>

		<slot />
	</div>
</template>

<script>
	import CircleNumber from '@/components/CircleNumber.vue';

	export default {
		components: { CircleNumber },

		props: ['number', 'text', 'isDisabled'],
	}
</script>

<style lang="scss" scoped>
	@import '@/styles/variables';
	@import '@/styles/mixins';

	.step-title {
		&.is-disabled {
			.step-title__title,
			.step-title__number {
				@include disabled-text();
			}
		}

		&.has-slot-content {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		&__title-wrapper {
			display: flex;
			align-items: center;
		}

		&__number {
			margin-right: 20px;
		}

		&__title {
			@include heading-01();
			color: $white;
		}
	}
</style>
